import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useContext, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { toQueryString } from "components/hooks/useQueryStringState";
import { Link } from "react-router-dom";

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  "& .MuiTypography-root": {
    fontSize: theme.fontSize.sm,
    fontWeight: theme.fontWeight[400],
  },
}));

const StyledSubListItemText = styled(ListItemText)(({ theme }) => ({
  "& .MuiTypography-root": {
    fontWeight: theme.fontWeight[200],
    fontSize: theme.fontSize.sm,
  },
}));

const StyledCollapse = styled(Collapse)({
  paddingLeft: 8,
  paddingRight: 8,
});

const MenuFooter = ({ app }) => {
  const theme = useTheme();
  const [openAccount, setOpenAccount] = useState(false);
  const { logout } = useContext(AuthenticationContext);

  const handleOpenAccount = () => {
    setOpenAccount(!openAccount);
  };

  return (
    <Box sx={{ width: 1 }}>
      <StyledCollapse in={openAccount} timeout="auto" unmountOnExit>
        <List dense={true}>
          <ListItemButton
            component={Link}
            to={{
              pathname: "/automated_tasks",
              search: toQueryString({
                sort: { ordering: "-created_at" },
              }),
            }}
          >
            <StyledSubListItemText>Automated tasks</StyledSubListItemText>
          </ListItemButton>
          <ListItemButton
            href={`${process.env.REACT_APP_SERVICE_URL}/api/from_front?next=/admin/`}
          >
            <StyledSubListItemText>Admin</StyledSubListItemText>
          </ListItemButton>
          {app !== "ringback" && (
            <ListItemButton component={Link} to={"/backoffice"}>
              <StyledSubListItemText>RingBack</StyledSubListItemText>
            </ListItemButton>
          )}
          {app !== "ringapp" && (
            <ListItemButton component={Link} to={"/"}>
              <StyledSubListItemText>RingApp</StyledSubListItemText>
            </ListItemButton>
          )}
          <ListItemButton component={Link} to={"/account"}>
            <StyledSubListItemText>Account</StyledSubListItemText>
          </ListItemButton>
          <ListItemButton onClick={logout}>
            <StyledSubListItemText>Logout</StyledSubListItemText>
          </ListItemButton>
        </List>
      </StyledCollapse>
      <ListItemButton onClick={handleOpenAccount}>
        <ListItemIcon>
          <SettingsIcon
            sx={{ scale: "0.75", color: theme.palette_custom.darkBlue }}
          />
        </ListItemIcon>
        <StyledListItemText>Account</StyledListItemText>
        {openAccount ? (
          <ExpandMoreIcon fontSize={theme.fontSize.sm} />
        ) : (
          <ExpandLessIcon fontSize={theme.fontSize.sm} />
        )}
      </ListItemButton>
    </Box>
  );
};

export default MenuFooter;
